import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import NewsletterManagementPage from "@/pages/admin/NewsletterManagementPage";

export const Route = createFileRoute("/_admin/admin/newsletter")({
  head: () => pageHead("Admin · Newsletter", "AKIVA admin · newsletter portal.", "/admin/newsletter", true),
  component: NewsletterManagementPage,
});
